import type { TestBenchResult } from '../stores/testBenchStore';
import type { ModelPricingMap } from '../types';

// Dollar cost of one bench run from its token usage + the registry's per-model
// price (same pricing source Settings uses). Null when usage or price is
// unavailable. Shared by the Model Test Bench and the Prompt Test Bench.
export function runCost(res: TestBenchResult, pricing: ModelPricingMap): number | null {
  const u = res.usage as { prompt_tokens?: number; completion_tokens?: number } | null | undefined;
  const p = res.model ? pricing[res.model] : undefined;
  if (!u || !p || p.input == null || p.output == null) return null;
  return ((u.prompt_tokens || 0) / 1_000_000) * p.input + ((u.completion_tokens || 0) / 1_000_000) * p.output;
}

export function fmtCost(n: number | null | undefined): string {
  if (n == null) return '—';
  if (n === 0) return '$0';
  return n < 0.01 ? `~$${n.toFixed(5)}` : `$${n.toFixed(4)}`;
}
